export default __webpack_public_path__ + "static/media/jewelry-hot-spring.57faea87.png";